(function () {
    'use strict';

    angular
        .module('core', [
            'ngSanitize',

            'ui.router',
            'smart-table',
            '19degrees.ngSweetAlert2',
            'angularValidator',
            'ngMask',
            'ui.select',
            'ngNotify',
            'ui.bootstrap.datetimepicker',
            'flow',
            'lodash',

            'core.configs',
            'core.constants',
            'core.components',
            'core.directives',
            'core.filters',
            'core.interceptors',
            'core.routes',
            'core.services',

            'franchisee',
            'franchiser'
        ])
        .run(run);

    /** @ngInject */
    function run($trace, $transitions, $rootScope, $window, HelperService) {
        $trace.enable(1, 5);

        HelperService.handleOnRun();

        $rootScope.$on('$locationChangeStart', event => {
            HelperService.handleLocationChangeStart(event);
        });

        $transitions.onEnter({}, $transition => {
            return HelperService.handleStateChangeStart($transition);
        });

        $transitions.onSuccess({}, $transition => {
            $rootScope.pageTitle = `${$transition.to().title} - SSO`;

            HelperService.handleStateChangeSuccess();
        });

        $transitions.onError({}, ($transition, error) => {
            console.log('$transition: ', $transition);
            console.log('error: ', error);
            HelperService.handleStateChangeError(error);
        });

        $window.onload = () => {
            HelperService.handleViewContentLoaded();
        }

        $rootScope.$on('$viewContentLoaded', HelperService.handleViewContentLoaded);
    }
})();